<script setup lang="ts">
import { useHead } from '@unhead/vue';
import AppImage from '@/components/shared/AppImage.vue';
import Layout from '@/layout/Layout.vue';

useHead({
  title: "Albano's Villa | Home",
  meta: [
    {
      name: 'description',
      content:
        "Family-owned Albano's Villa has served Sicilian-recipe pizza, pasta, sandwiches and tacos in Michigan City and LaPorte, Indiana since 1957.",
    },
  ],
});
</script>

<template>
  <Layout>
    <h1 class="sr-only">Albano's Villa</h1>
    <AppImage name="albanos-home" alt="Albano's Villa" sizes="600px" img-class="mx-auto" eager />
    <p>
      The Albano's Villa legend begins with our pizza. Family recipes from Sicily passed through the
      generations have helped us create a distinct sauce and the perfect crust. Fresh ingredients
      make it all the better. Add your favorite toppings, and you have a masterpiece.
    </p>
    <p>
      And it doesn't end there. While pizza is at the core of our menu, our pasta, sandwiches, and
      even our tacos are just as unforgettable.
    </p>
    <p>
      Albano's has been in the same family for more than 50 years, and we are proud that our food
      has become an institution. Ask anyone who has dined with us - from Michigan City and LaPorte,
      Indiana to San Bernardino, California. Chances are they'll say Albano's is their favorite
      pizza. We cherish the loyalty of our customers and strive to stay that way. The proof is in
      the pie ... and the tacos ... and the sandwiches ... and the pasta.
    </p>
  </Layout>
</template>
